import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import Orb from "../IntroPage/Orb";
import BlurText from "@/router/ui/BlurText";
import AuraNexusLogo from "@/assets/AuraNexus_logo.png";
import PoliceLogo from "@/assets/police_logo.png";
import "./NotFoundPage.css";
import "../IntroPage/Orb.css";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="notfound-page-container">
      {/* Orb Background */}
      <div className="orb-background">
        <Orb
          hoverIntensity={0.4}
          rotateOnHover={true}
          forceHoverState={false}
        />
      </div>

      {/* Content Container */}
      <div className="content-container">
        <div className="notfound-screen">
          <div className="logo-container">
            <img src={AuraNexusLogo} alt="AuraNexus Logo" className="logo" />
          </div>

          <BlurText
            text="404"
            delay={50}
            animateBy="words"
            direction="top"
            className="notfound-code"
            stepDuration={0.2}
          />

          <BlurText
            text="页面未找到"
            delay={80}
            animateBy="words"
            direction="top"
            className="notfound-title"
            stepDuration={0.3}
          />

          <div className="notfound-description">
            <BlurText
              text="抱歉，您访问的页面不存在或已被移动。"
              delay={100}
              animateBy="words"
              direction="top"
              className="notfound-message"
              stepDuration={0.3}
            />
          </div>

          {/* Navigation Buttons */}
          <div className="notfound-buttons">
            <button onClick={handleGoHome} className="notfound-btn home-btn">
              <Home size={20} />
              返回首页
            </button>

            <button onClick={handleGoBack} className="notfound-btn back-btn">
              <ArrowLeft size={20} />
              返回上页
            </button>
          </div>
        </div>
      </div>

      {/* 备案信息 */}
      <div className="filing-info">
        <div className="filing-links">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            className="filing-link"
          >
            陕ICP备2025076219号-1
          </a>
          <span className="filing-separator">|</span>
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=61011302002156"
            target="_blank"
            rel="noopener noreferrer"
            className="filing-link police-filing"
          >
            <img
              src={PoliceLogo}
              width="16"
              height="16"
              alt="公安备案"
              className="police-logo"
            />
            陕公网安备61011302002156号
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
